module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar3-week-fill-75d18c85.svg";